import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { LinkedInIcon, GitHubIcon, SunIcon, MoonIcon } from './Icons';
import './Navbar.css';

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="navbar">
      <Link to="/" className="navbar-brand">
        jf
      </Link>

      <div className="navbar-actions">
        <a
          href="https://github.com/Athena96"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-icon-btn"
          aria-label="GitHub"
          title="GitHub"
        >
          <GitHubIcon size={18} />
        </a>
        <a
          href="https://www.linkedin.com/in/jaredfranzone/"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-icon-btn"
          aria-label="LinkedIn"
          title="LinkedIn"
        >
          <LinkedInIcon size={18} />
        </a>
        <button
          onClick={toggleTheme}
          className="theme-toggle-btn"
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === 'light' ? <MoonIcon size={17} /> : <SunIcon size={17} />}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
